export default __webpack_public_path__ + "static/media/714.5d1eb47a.png";